module.exports = __webpack_public_path__ + "img/bakery.9494b5d1.svg";